var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('b-table',{attrs:{"fixed":"","striped":"","hover":"","items":_vm.items}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }